<template>
  <v-skeleton-loader
    :loading="loading"
    transition="scale-transition"
    type="image"
    height="120px"
  >
    <mini-statistic
      :icon="icon"
      :title="this.totalQuestions.toString()"
      :sub-title="subTitle"
      :color="color"
    >
    </mini-statistic>
  </v-skeleton-loader>
</template>

<script>
import MiniStatistic from "../statistic/MiniStatistic";
import DashboardService from "@/services/dashboard.service";

export default {
  components: { MiniStatistic },
  props: {
    icon: String,
    title: String,
    subTitle: String,
    color: String,
    type: Number,
    dateRange: {
      type: String,
      default: "currentDay",
    },
  },
  created() {
    this.dateRangeChanged();
  },
  data() {
    return {
      loading: true,
      totalQuestions: 0,
    };
  },
  watch: {
    // whenever question changes, this function will run
    dateRange: function (newProp, oldProp) {
      this.dateRangeChanged();
    },
  },
  methods: {
    dateRangeChanged() {
      this.loading = true;
      DashboardService.getQuestionSolved(this.type, this.dateRange).then(
        (r) => {
          this.totalQuestions = r.data.total;
          this.loading = false;
        },
      );
    },
  },
};
</script>
